export interface Review {
  id: number;
  name: string;
  avatar: string;
  rating: number;
  content: string;
  date: string;
  source: string;
}

export const reviews: Review[] = [
  {
    id: 1,
    name: "漫画迷小王",
    avatar: "",
    rating: 5,
    content: "这个韩漫网站真的太棒了！画质高清，下拉式阅读体验非常流畅，不用翻页就能一直往下看。漫画种类也很全，我喜欢的爱情和奇幻类都有很多选择。强烈推荐给喜欢看韩漫的朋友！",
    date: "2026-07-15",
    source: "小红书",
  },
  {
    id: 2,
    name: "追漫少女",
    avatar: "",
    rating: 5,
    content: "找了很久才找到这么好用的韩漫在线阅读平台。更新速度很快，热门漫画基本同步更新。界面设计简洁清爽，没有乱七八糟的广告。已经推荐给身边所有喜欢看漫画的闺蜜了！",
    date: "2026-07-20",
    source: "微博",
  },
  {
    id: 3,
    name: "二次元阿宅",
    avatar: "",
    rating: 4,
    content: "从韩国朋友那里知道这个网站的，没想到国内也能看到这么多正版韩漫。免费下拉式阅读方式很舒服，适合手机和电脑观看。希望以后能增加更多完结漫画的完整合集。",
    date: "2026-07-28",
    source: "豆瓣",
  },
  {
    id: 4,
    name: "漫画研究员",
    avatar: "",
    rating: 5,
    content: "作为一个韩漫爱好者，我几乎每天都会来这里看看有没有更新。网站的漫画分类很清晰，爱情、奇幻、动作、悬疑等种类齐全。阅读体验一流，高清画质让人沉浸其中。这是目前我用过最好的韩漫网站！",
    date: "2026-08-01",
    source: "知乎",
  },
  {
    id: 5,
    name: "小明的漫画屋",
    avatar: "",
    rating: 5,
    content: "发现这个宝藏韩漫网站后，我的休闲时间都贡献在这里了。下拉式漫画阅读太方便了，不用繁琐的翻页操作。特别喜欢《星光下的约定》和《剑与魔法之王国》，画风精美剧情精彩。五星好评！",
    date: "2026-08-02",
    source: "微信公众号",
  },
  {
    id: 6,
    name: "夜猫子阅读者",
    avatar: "",
    rating: 4,
    content: "晚上睡不着的时候就会打开这个网站看韩漫，高清画质在手机上看也很清晰。韩国漫画全集的资源很丰富，很多热门作品都能找到。希望能长期保持这样的更新频率和阅读体验。",
    date: "2026-08-03",
    source: "小红书",
  },
];

export const aboutInfo = {
  brandName: "韩漫在线",
  slogan: "高清韩漫，畅享阅读",
  founded: "2024",
  description: "韩漫在线是国内领先的韩国漫画在线阅读平台，致力于为广大漫画爱好者提供高清、流畅、免费的韩国漫画阅读体验。我们与韩国多家知名漫画工作室建立了深度合作关系，确保平台上的漫画内容正版、优质、丰富。",
  mission: "我们的使命是打破语言和地域的障碍，让每一位中文读者都能轻松享受韩国漫画的魅力。通过不断优化的下拉式阅读技术和高清画质呈现，我们为用户打造沉浸式的漫画阅读体验。",
  values: [
    { title: "正版内容", description: "与韩国多家漫画平台建立合作，确保所有漫画内容均获得正版授权，保障创作者权益。" },
    { title: "用户至上", description: "持续优化阅读体验，从高清画质到流畅加载，每一个细节都以用户满意度为核心。" },
    { title: "内容丰富", description: "覆盖爱情、奇幻、动作、悬疑、喜剧等多种类型，满足不同读者的口味需求。" },
    { title: "技术创新", description: "采用先进的下拉式阅读技术和自适应图片加载方案，让阅读体验更加顺畅自然。" },
  ],
  stats: [
    { number: "5000+", label: "漫画作品" },
    { number: "200万+", label: "月活用户" },
    { number: "10万+", label: "日更新章节" },
    { number: "98%", label: "用户好评率" },
  ],
  contact: {
    email: "contact@manhuaonline.com",
    wechat: "韩漫在线官方",
    weibo: "@韩漫在线",
    address: "北京市朝阳区望京SOHO",
    phone: "400-888-0000",
    workHours: "周一至周五 9:00 - 18:00",
  },
  faqs: [
    {
      question: "韩漫在线上的漫画都是免费的吗？",
      answer: "是的，韩漫在线平台上的所有韩国漫画内容均提供免费在线阅读。我们通过广告和会员增值服务来维持平台运营，确保用户能够免费享受高质量的漫画阅读体验。部分独家内容可能需要注册会员后才能阅读。",
    },
    {
      question: "如何下载漫画到本地观看？",
      answer: "目前韩漫在线支持在线下拉式阅读，暂不提供下载功能。在线阅读可以享受高清画质和自动同步阅读进度的便利。您可以在任何有网络连接的设备上随时随地继续阅读。",
    },
    {
      question: "漫画更新频率是怎样的？",
      answer: "韩漫在线与韩国漫画工作室保持紧密合作，热门连载漫画通常每周更新1-2话。我们会在第一时间将最新章节同步上线，确保读者能够尽快看到最新内容。您可以关注我们的更新日历了解具体更新安排。",
    },
    {
      question: "支持哪些设备阅读？",
      answer: "韩漫在线采用响应式设计，完美支持PC电脑、平板和手机等多种设备。下拉式阅读方式在手机端的体验尤为出色，无需翻页即可连续阅读。建议使用Chrome、Safari等现代浏览器获得最佳阅读体验。",
    },
    {
      question: "如何反馈问题或提供建议？",
      answer: "我们非常重视每一位用户的反馈。您可以通过网站底部的联系方式发送邮件，或者关注我们的微博和微信公众号留言。我们的客服团队会在24小时内回复您的信息。",
    },
  ],
};